module.exports = __webpack_public_path__ + "static/media/card1.a31ffc7c.jpg";